// extracted by mini-css-extract-plugin
export var avatarContainer = "_d1-0";
export var avatarTypingWave = "_d1-i";
export var gray = "_d1-f";
export var green = "_d1-c";
export var icon = "_d1-9";
export var image = "_d1-1";
export var lg = "_d1-6";
export var md = "_d1-5";
export var presenceDot = "_d1-b";
export var red = "_d1-d";
export var sm = "_d1-4";
export var status = "_d1-a";
export var typingDot = "_d1-h";
export var typingPill = "_d1-g";
export var xl = "_d1-7";
export var xs = "_d1-3";
export var xxl = "_d1-8";
export var xxs = "_d1-2";
export var yellow = "_d1-e";